// extracted by mini-css-extract-plugin
export var animationContainer = "_ij-0";
export var asteriskIcon = "_ij-8";
export var conversationLeftSection = "_ij-4";
export var conversationListItem = "_ij-3";
export var conversationMiddleSection = "_ij-5";
export var conversationRightSection = "_ij-6";
export var detailsContent = "_ij-1";
export var listContainer = "_ij-7";
export var modalContent = "_ij-2";